const faqList = [
  {
    question: "How to cancel AutoPay / automatic payments from UPI apps?",
    answer: (
      <>
        PhonePe / Google Pay / Paytm / BHIM
        <br />
        <br />
        <ol>
          <li>1. Open your UPI app</li>
          <li>2. Go to Autopay / Mandates / Subscriptions</li>
          <li>
            3. Find the mandate for Seekho / Keyaro Edutech Private Limited
          </li>
          <li>4. Tap Cancel / Pause / Revoke / Delete mandate</li>
          <li>5. Confirm with UPI PIN </li>
          <span style={{ opacity: "70%" }}>
            No money will be deducted while cancelling. The PIN is only for
            authorization to stop the auto-debit
          </span>
          <br />
          <br />
          After this, future debits stop.
        </ol>
      </>
    ),
  },
  {
    question: "What is Seekho App Refund Policy?",
    answer:
      "Please Refer to all the policies: https://seekho.in/cancellation-policy",
  },
];

const customerServices = [
  "Subscription & Payment Issues",
  "App Download & Installation Help",
  "Video Access & Technical Support",
  "Account Management Queries",
  "Refund Related Issues",
];

export { faqList, customerServices };
